import {
  Flex,
  FlexProps,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
} from "@chakra-ui/react";
import { SearchIcon } from "@root/assets/images";
import useCustomTheme from "@root/hooks/useCustomTheme";
import React from "react";
import { useTranslation } from "react-i18next";

interface ChatHeaderProps extends FlexProps {
  title?: any;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: () => void;
  showRightInput?: boolean;
  onDateSelect?: any;
  onClear?: any;
  dates?: any;
}

export const AppHeader: React.FC<ChatHeaderProps> = ({
  onSearchChange,
  onKeyDown,
  title,
  showRightInput = false,
  onDateSelect,
  onClear,
  dates,
  ...props
}) => {
  const { t } = useTranslation("common");
  const { isDarkTheme } = useCustomTheme();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (typeof onKeyDown === "function") {
        onKeyDown();
      }
    }
  };


  return (
    <Flex
      display={"flex"}
      gap={"10px"}
      width="100%"
      justifyContent={"space-between"}
      alignContent={"center"}
      borderColor={"gray.600"}
      backgroundColor="trasparent"
      {...props}
    >
      <Spacer />

      {showRightInput && (
        <InputGroup
          maxW={"220px"}
          height={"50px"}
          backgroundColor="white"
          border={"1px solid "}
          borderColor={"theme.gray.25"}
          borderRadius={"4px"}
          overflow={"hidden"}
        >
          <InputRightElement
            cursor={"pointer"}
            children={
              <SearchIcon
                color={!isDarkTheme ? "theme.gray.500" : "theme.gray.300"}
              />
            }
          />
          <Input
            placeholder={t("chat.search")}
            onChange={onSearchChange}
            onKeyDown={handleKeyDown}
            size="xs"
            height={"50px"}
            border={"none"}
          />
        </InputGroup>
      )}
      {/* {dates && onDateSelect && (
        <Box
          position={"relative"}
          width={"200px"}
          height={"50px"}
          backgroundColor="white"
        >
          <DateField
            padding={0}
            height="50px"
            placeholder={t("user_dashboard.dateRange")}
            value={startDate && endDate ? [startDate, endDate] : undefined}
            onChange={handleDateChange}
            onClear={clearDates}
            disabled={false}
            isISO
            range
            inputWidth="200px"
          />
        </Box>
      )} */}
    </Flex>
  );
};

export default AppHeader;
